// Import the script and execute it. The output will be set in webpack public path variable
// (aliased as 'p')
import getCurrentScriptUrl from "./getCurrentScriptUrl";

interface WebpackRequire {
  g: { document: Document & { importScripts: unknown } };
  p: string;
}

declare const __webpack_require__: WebpackRequire;
__webpack_require__.p = getCurrentScriptUrl();
